export default __webpack_public_path__ + "static/media/step2.141e02e6.svg";